import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[100dvh] flex flex-col pt-24 md:pt-20" data-id="element-118">
      {/* Background image with elegant overlay */}
      <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-119">
        <img src="https://cdn.magicpatterns.com/uploads/fbQ74FsC3s2dT3V3tvS8GU/2.png" alt="" className="w-full h-full object-cover object-center" aria-hidden="true" data-id="element-120" />
        {/* Soft white overlay for text readability */}
        <div className="absolute inset-0 bg-white/[0.55]" data-id="element-121" />

        {/* Decorative background elements - hidden on mobile */}
        <div className="hidden md:block absolute top-1/4 left-10 text-amber-300/30 animate-pulse" data-id="element-122">
          <Sparkles size={64} data-id="element-123" />
        </div>
        <div className="hidden md:block absolute bottom-1/4 right-10 text-violet-300/30 animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-124">
          <Sparkles size={48} data-id="element-125" />
        </div>
        <div className="absolute top-1/2 right-1/4 w-72 h-72 bg-amber-200/20 rounded-full blur-3xl" data-id="element-126" />
        <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-violet-200/15 rounded-full blur-3xl" data-id="element-127" />
      </div>

      {/* Main content - centered vertically via flex-grow */}
      <div className="relative z-10 flex-1 flex items-center justify-center px-6 sm:px-8 lg:px-8" data-id="element-128">
        <div className="max-w-4xl mx-auto text-center" data-id="element-129">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-130">
            <span className="inline-block py-1.5 px-4 rounded-full bg-white/70 backdrop-blur-sm text-violet-600 text-xs sm:text-sm font-medium tracking-wide mb-6 shadow-sm" data-id="element-131">
              Terapia Holística y Mediumnidad
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-serif text-stone-900 leading-tight mb-6" data-id="element-132">
            Descubre lo que tu alma ya sabe y{' '}
            <span className="text-violet-600 italic" data-id="element-133">transforma tu vida</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="text-base sm:text-lg md:text-xl text-stone-700 mb-8 sm:mb-10 max-w-2xl mx-auto font-light" data-id="element-134">
            Acompañamiento espiritual y terapéutico para sanar, comprender y
            evolucionar.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="flex items-center justify-center" data-id="element-135">
            <a href="#servicios" className="px-10 py-4 bg-violet-600 text-white text-base sm:text-lg rounded-full font-medium hover:bg-violet-700 transition-all shadow-lg hover:shadow-xl flex items-center justify-center group" data-id="element-136">
              Reservar sesión
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-137" />
            </a>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.9
        }} className="mt-5 sm:mt-6 text-xs sm:text-sm text-stone-500 font-light" data-id="element-138">
            Si tienes dudas o no sabes qué sesión elegir, puedes escribirme sin
            compromiso
          </motion.p>
        </div>
      </div>

      {/* Scroll indicator - in document flow, always visible */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2,
      duration: 1
    }} className="relative z-10 flex flex-col items-center pb-6 sm:pb-10 pt-6 sm:pt-4" data-id="element-139">
        <motion.span animate={{
        y: [0, 4, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="text-[10px] sm:text-xs text-stone-500 uppercase tracking-widest mb-2" data-id="element-140">
          Descubrir
        </motion.span>
        <motion.div animate={{
        y: [0, 4, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="w-[1px] h-8 sm:h-12 bg-gradient-to-b from-stone-400 to-transparent" data-id="element-141" />
      </motion.div>
    </section>;
}